import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InternalCluster } from "./_internal/InternalCluster.js";
const Cluster = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(InternalCluster, {
        as: "div",
        ...props,
        ref: ref
    }));
Cluster.displayName = 'Cluster';
export { Cluster };
